import { isAppsInTossHost } from "./apps-in-toss";
export function apiBase() {
  return isAppsInTossHost() ? (import.meta.env.VITE_SYNC_API_BASE || "https://haebolkae.com") : window.location.origin;
}
